import type React from 'react';

import { useDefinitions } from '@/core/providers';

export const CompanyLogo: React.FC = () => {
	const { defs } = useDefinitions();

	return <img src={defs.customization.logo_url} style={{ maxHeight: '56px', width: 'auto' }} alt="logo image" />;
};
